<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.home.Registro_licencias') }}</span>
            <router-link class="item" to="/newlicense" style="position: absolute;right: 22px;bottom: -50px;">
              <div class="ui right floated small olive labeled icon button rounded">
                <i class="plus icon"></i>{{ $t("components.registeredLicenses.Registrar_nuevo") }}
              </div>
            </router-link>
          </div>
          <h3 class="ui dividing header">{{ $t("components.registeredLicenses.Listado_de_licencias") }}</h3>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <RegisteredLicenses></RegisteredLicenses>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisteredLicenses from '@/components/RegisteredLicenses.vue';

export default {
  name: 'Licenses',
  components: {
    RegisteredLicenses
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
